import { render, staticRenderFns } from "./HotspotButton.vue?vue&type=template&id=bf1d193e&scoped=true&"
import script from "./HotspotButton.vue?vue&type=script&lang=js&"
export * from "./HotspotButton.vue?vue&type=script&lang=js&"
import style0 from "./HotspotButton.vue?vue&type=style&index=0&id=bf1d193e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d193e",
  null
  
)

export default component.exports